module.exports = __webpack_public_path__ + "static/media/svg.16b4ac39.svg";